import React from 'react';
import { FaEdit, FaTrashAlt } from 'react-icons/fa';

const CentralWastageTable = ({
    wastageItems,
    getStockItemByName,
    hasSecondaryUnit,
    editingItemId,
    handleEditItem,
    handleRemoveItem,
    handleSubmit,
    isLoading
}) => {
    if (wastageItems.length === 0) return null;

    return (
        <div className="mt-6">
            <h3 className="text-lg font-medium mb-2">Wasted Items</h3>

            <div className="rounded-md border overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200 text-sm text-center">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="px-6 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Item Name
                            </th>

                            <th className="px-6 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Rate
                            </th>

                            <th
                                className="px-6 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider"
                                colSpan="2"
                            >
                                Primary Unit
                            </th>

                            <th
                                className="px-6 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider"
                                colSpan="2"
                            >
                                Secondary Unit
                            </th>

                            <th className="px-6 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Actions
                            </th>
                        </tr>

                        <tr>
                            <th></th>
                            <th></th>

                            <th className="px-6 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider border-r">
                                UOM
                            </th>

                            <th className="px-6 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Qty
                            </th>

                            <th className="px-6 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider border-r">
                                UOM
                            </th>

                            <th className="px-6 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Qty
                            </th>

                            <th></th>
                        </tr>
                    </thead>

                    <tbody className="bg-white divide-y divide-gray-200">
                        {wastageItems.map((item) => {
                            const stockItem = getStockItemByName(item.item_name);
                            const showSecondary =
                                stockItem && hasSecondaryUnit(stockItem);

                            return (
                                <tr
                                    key={item.id}
                                    className={
                                        editingItemId === item.id
                                            ? "bg-yellow-50"
                                            : ""
                                    }
                                >
                                    <td className="px-6 py-4">
                                        {item.item_name}
                                    </td>

                                    <td className="px-6 py-4">
                                        {stockItem?.rate || "-"}
                                    </td>

                                    {/* PRIMARY UNIT */}
                                    <td className="px-6 py-4">
                                        {stockItem?.uom || "-"}
                                    </td>

                                    <td className="px-6 py-4">
                                        {item.mainQty || 0}
                                    </td>

                                    {/* SECONDARY UNIT */}
                                    {showSecondary ? (
                                        <>
                                            <td className="px-6 py-4">
                                                {stockItem?.unit_definition?.uom || "-"}
                                            </td>

                                            <td className="px-6 py-4">
                                                {item.subQty || 0}
                                            </td>
                                        </>
                                    ) : (
                                        <>
                                            <td className="px-6 py-4">-</td>
                                            <td className="px-6 py-4">-</td>
                                        </>
                                    )}

                                    {/* ACTIONS */}
                                    <td className="px-6 py-4 space-x-2">
                                        <button
                                            className="text-blue-600 hover:text-blue-800"
                                            onClick={() => handleEditItem(item)}
                                        >
                                            <FaEdit />
                                        </button>

                                        <button
                                            className="text-red-600 hover:text-red-800"
                                            onClick={() =>
                                                handleRemoveItem(item.id)
                                            }
                                        >
                                            <FaTrashAlt />
                                        </button>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>

            <div className="mt-3 flex justify-end">
                <button
                    className="bg-green-600 text-white text-sm py-1.5 px-4 rounded-md hover:bg-green-700 disabled:bg-gray-400"
                    onClick={handleSubmit}
                    disabled={isLoading}
                >
                    {isLoading ? "Saving..." : "Save Wastage"}
                </button>
            </div>
        </div>
    );
};

export default CentralWastageTable;